/**
 * CardTitle Component
 *
 * Title sub-component for compound Card API
 * Provides typography styling with size variants (16px vs 20px)
 */

import React from 'react';
import { cx } from '@/styled-system/css';
import { cardTitle } from './card.styles';
import type { CardTitleProps } from './types';

export const CardTitle = React.forwardRef<HTMLHeadingElement, CardTitleProps>(
  ({ children, size = 'lg', className, ...restProps }, ref) => {
    return (
      <h3 ref={ref} className={cx(cardTitle, className)} data-size={size} {...restProps}>
        {children}
      </h3>
    );
  },
);

CardTitle.displayName = 'CardTitle';

export type { CardTitleProps };
